<template>
  <el-form
    :model="form"
    ref="form">
    <el-form-item
      :label="L10n('name')"
      prop="name"
      :rules="getValidationRule('required,minLength')"
      class="material-style">
      <el-input
        ref="firstField"
        :value="form.name"
        @input="form.name = valueTrimLeft($event)"/>
    </el-form-item>
  </el-form>
</template>

<script>
import Form from '@/components/Form/Form'

export default {
  name: 'FormCompanies',
  mixins: [Form]
}
</script>
